// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o0c5","name":"styles_name__S1kt2","phone":"styles_phone__R4w3W"};